import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import KlaroLogo from '@/components/haccp/KlaroLogo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!email || !email.includes('@')) return toast.error('Inserisci un\'email valida');
    setSubmitting(true);
    try {
      const r = await fetch(`${BACKEND_URL}/api/auth/forgot-password`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(d.detail || 'Errore invio richiesta');
      }
      setSent(true);
    } catch (e) { toast.error(e.message); } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="surface max-w-md w-full p-8">
        <KlaroLogo />
        {sent ? (
          <div className="mt-6 text-center">
            <h1 className="font-heading text-2xl font-semibold text-emerald-600">Controlla la tua email</h1>
            <p className="mt-2 text-sm text-[#475467]">Se <strong>{email}</strong> è registrata, ti abbiamo inviato un link per reimpostare la password. Il link scade tra 30 minuti.</p>
            <p className="mt-6 text-xs text-[#98A2B3]"><Link to="/login" className="hover:underline">← Torna al login</Link></p>
          </div>
        ) : (
          <>
            <h1 className="mt-6 font-heading text-2xl font-semibold">Password dimenticata?</h1>
            <p className="mt-1 text-sm text-[#475467]">Inserisci l'email del tuo account. Ti invieremo un link per reimpostare la password.</p>
            <div className="mt-5 space-y-4">
              <div><Label>Email</Label><Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && submit()} /></div>
              <Button data-testid="forgot-submit-btn" variant="success" className="w-full" onClick={submit} disabled={submitting}>{submitting ? 'Invio…' : 'Invia link di reset'}</Button>
              <p className="text-center text-xs text-[#98A2B3]"><Link to="/login" className="hover:underline">← Torna al login</Link></p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
